import { createSlice } from "@reduxjs/toolkit";

const home = createSlice({
  name: "Home",
  initialState: {},
  reducers: {
    /**
     * QRコードデータの生成完了
     */
    builtQrCode(state, action) {
      state.qrCodeSrc = action.payload;
    },
    /**
     * リロード
     */
    setLoading(state, action) {
      state.loading = action.payload;
    },
    /**
     * fetchMyInformation の実行に成功した
     */
    succeededFetchMyInformationApi(state, action) {
      state.myInformation = action.payload;
    },
    /**
     * fetchTransientRewardToken の実行が成功した
     */
    succeededFetchTransientRewardTokenApi(state, action) {
      state.rewardAmount = action.payload.reward_amount;
      state.timer = 60; // QR の更新サイクル (秒)

      // 強制リロードの時間を一定時間後にセット
      // 古すぎる QR コードが表示されるケースがあったため
      // Refer to https://redmine.haw.biz/issues/4401
      state.forceReloadingAt = new Date();
      state.forceReloadingAt.setSeconds(
        state.forceReloadingAt.getSeconds() + 70
      );
    },
    /**
     * タイマーの秒針変更
     */
    tickTimer(state, action) {
      if (state.timer > 0) {
        state.timer -= 1;
      } else {
        state.timer = 0;
      }
    },
    /**
     * サインアウト
     */
    signedOut(state, action) {
      state.signedOut = true;
    },
    /**
     * パスワード変更要求が発生した
     */
    changePasswordRequired(state, action) {
      state.changePasswordRequired = true;
    },
  },
});

const { reducer } = home;
export const { actions } = home;
export default reducer;
